module.exports = __webpack_public_path__ + "img/message.183a46f5.png";